export default {
      id: "ic_nav_droite-usage",
      viewBox: "0 0 40 40",
      url: "../dist/images/" + "sprite.svg#ic_nav_droite-usage",
      toString: function () {
        return this.url;
      }
    }